import React from 'react'

import { IconSizes } from '@inno-ui/icons'
import classNames from 'classnames'
import { motion } from 'motion/react'
import { BadgeCount } from 'shared/components/BadgeCount/BadgeCount'

import styles from './ActionButton.module.scss'
import { ActionButtonProps } from './ActionButton.types'

export const ActionButton: React.FC<ActionButtonProps> = ({
  Icon,
  onClick,
  index,
  ariaLabel,
  isActive,
  tourId,
  unreadCount
}) => {
  const onKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      onClick()
    }
  }

  return (
    <div className={styles.actionButtonWrapper} data-tour={tourId}>
      <motion.div
        onClick={onClick}
        onKeyDown={onKeyDown}
        role='button'
        tabIndex={0}
        aria-label={ariaLabel}
        initial={{
          scale: 0,
          opacity: 0,
          y: 20
        }}
        animate={{
          scale: 1,
          opacity: 1,
          y: 0
        }}
        transition={{
          delay: index * 0.05
        }}
        whileTap={{
          scale: 0.95
        }}
        className={classNames(styles.iconContainer, {
          [styles.active]: isActive
        })}
      >
        <Icon
          className={styles.icon}
          color={isActive ? 'white' : 'var(--grey-600)'}
          size={IconSizes.Size24}
        />
        <BadgeCount count={unreadCount ?? 0} className={styles.badgeTopRight} />
      </motion.div>
    </div>
  )
}
